<template lang="html">
  <li class="navbar-account-menu dropdown nav-item auto">

    <!-- Account menu button -->
    <a
      class="nav-link mt-sm-1 px-2" href="#"
      id="dropdownMenu2"
      data-toggle="dropdown"
      @click="pushToDataLayer('User menu', 'My account')"
      aria-haspopup="true"
      aria-expanded="false">
      <span style="position: relative">
        <font-awesome-icon class="d-lg-none menu-icon" :icon="[ 'fas', 'user-circle' ]" />
        <NotificationSign :active="isAuth && !!unansweredQuestions" class="d-md-none" right/>
      </span>
      Mi cuenta
    </a>

    <!-- Account menu items -->
    <div
      @click="handleClose"
      ref="accountMenuDropable"
      class="dropdown-menu dropdown-menu-right pt-0" aria-labelledby="dropdownMenu2">

      <!-- email label -->
      <div class="navbar-account-user bg-light px-3 py-0">
        <div class="navbar-account-user-name py-1">
          {{ email }}
        </div>
      </div>

      <!-- Marketplace options -->
      <template v-for="(item, index) in listMkt">
        <div :key="`${index}-${item.id}`" class="d-flex py-0" v-if="!item.hidden">
          <BadgeCounter v-if="item.route === 'userQuestions'"
                        style="margin-left: 0.18rem;"
                        :count="unansweredQuestions" />
          <router-link v-if="item.route"
                       @click.native="pushToDataLayer('User menu', `${item.action}`)"
                       :key="`${index}-${item.id}`"
                       class="dropdown-item py-2"
                       style='padding-left: 1.5rem'
                       :to="{ name: item.route, params: item.params }">
            {{ item.name }}
          </router-link>
        </div>
      </template>

      <!-- User options -->
      <template v-for="(item, index) in list">
        <div :key="`${index}-${item.id}`" class="d-flex py-0" v-if="!item.hidden">
          <router-link v-if="item.route"
                       @click.native="pushToDataLayer('User menu', `${item.action}`)"
                       :key="`${index}-${item.id}`"
                       class="dropdown-item py-2"
                       :style="item.route === 'userQuestions' && !!unansweredQuestions ? 'padding-left: 0.18rem' : 'padding-left: 1.5rem'"
                       :to="{ name: item.route, params: item.params }">
            {{ item.name }}
          </router-link>
        </div>
      </template>

      <!-- Separator -->
      <hr class="my-2"/>

      <!-- Logout -->
      <a class="dropdown-item footer" href="logout" @click.prevent="logout">Cerrar sesión</a>
    </div>
  </li>
</template>

<script>
import store from '@/store'
import { mapState, mapGetters } from 'vuex';

export default {
  data: () => ({
  }),

  computed: {
    ...mapGetters('user', ['isCommerce', 'marketplaceEnabled']),
    email: () => store.getters['user/email'],
    isAuth: () => store.state.user.isAuth || false,
    name: () => store.getters['user/name'],
    unansweredQuestions: () => {
      let count = store.state.user.newUnansweredQuestions || 0
      const pendingQuestions = store.state.user.publicationsPendingQuestions

      pendingQuestions.forEach(p => {
        count += p.questions_answers.length
      })
      return count > 99 ? '99+' : count
    },
    listMkt () {
      return [
        {
          name: 'Mis compras',
          route: 'userPurchases',
          params: {},
          action: 'My Purchases',
          hidden: false,
          id: 'purchases' // Unique identifier for the element
        },
        {
          name: 'Mis ventas',
          route: 'userSales',
          params: {},
          action: 'My Sales',
          hidden: !this.isCommerce || !this.marketplaceEnabled,
          id: 'sells' // Unique identifier for the element
        },
      ];
    },
    list () {
      return [
        {
          name: 'Mis Publicaciones',
          route: 'userPublications',
          params: {},
          action: 'My publications',
          id: 'publications'
        },
        {
          name: 'Perfil',
          route: 'userProfile',
          params: {},
          action: 'My profile',
          id: 'profile'
        },
        {
          name: 'Cuenta Corriente',
          route: 'userCheckingAccount',
          params: {},
          action: 'My checking account'

        },
        {
          name: 'Favoritos',
          route: 'userFavorites',
          params: {},
          action: 'My favorites',
          id: 'favorites'
        },
        {
          name: 'Preguntas recibidas',
          route: 'userQuestions',
          params: {tab: 'pendientes'},
          action: 'Questions',
          id: 'questions'
        },
        {
          name: 'Publicaciones de vendedores seguidos',
          route: 'userFollowedUserPublications',
          params: {},
          action: 'Followed users publications',
          id: 'followed-publications'
        },
        {
          name: 'Vendedores seguidos',
          route: 'userFollowedUsers',
          params: {},
          action: 'Followed users',
          id: 'followed-users'
        }
      ]
    }
  },

  methods: {
    logout () {
      return store.dispatch('user/logout')
        .then(() => {
          this.pushToDataLayer('User menu', 'Logout')
          const requiresAuth = this.$route && this.$route.meta.requiresAuth

          if (requiresAuth) this.$router.push({ name: 'home' })
        })
    },
    handleClose (e) {
      this.$emit('close')

      this.$refs.accountMenuDropable.classList.add('hidenow')
      setTimeout(() => {
        const menu = this.$refs.accountMenuDropable
        menu && menu.classList.remove('hidenow')
      }, 500)
    },
  },
  mounted () {
    store.dispatch('user/fetchPendingQuestions')
  }
}
</script>

<style lang="scss">
  @import '../../scss/aspect';
  @import '../../scss/colors';
  @import '../../scss/breakpoints';

  .navbar-account {
    &-user {
      width: 100%;
      height: 2rem;
      border-bottom: solid 1px #ced4da;
      font-weight: bold;

      &-name {
        width: fit-content;
        max-width: 17.5rem;
        margin-left: auto;
        margin-right: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        @media screen and (max-width: map-get($grid-breakpoints, "md")) {
          max-width: unset;
        }
      }
    }
    &-menu {
      @media screen and (max-width: map-get($grid-breakpoints, "md")) {
        .dropdown-item {
          & .footer {
            padding-left: 1.5rem;
            padding-top: 0 !important;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/layout/TheNavbarAccountMenu.vue